const colors = {
  grey1: '#3A3A3A',
  grey2: '#595959',
  grey4: '#949494',
  grey5: '#B4B4B4',
  grey50: '#F7FAFC',
  grey100: '#EDF2F7',
  grey200: '#E2E8F0',
  grey300: '#CBD5E0',
  grey700: '#2D3748',
  greyOther: '#6C6C6C',
  valencia: '#D24A43',
  richBlack: '#1A1A1A',
  successGreen: '#74B65F',
  errorRed: '#D24A43',
  // Color scheme for grey1
  projectGrey: {
    50: '#B4B4B4',
    100: '#878787',
    200: '#595959',
    300: '#4E4E4E',
    400: '#444444',
    500: '#3A3A3A',
    600: '#2E2E2E',
    700: '#252525',
    800: '#202020',
    900: '#1A1A1A',
  },
  // @HAQQY (for chakra-ui-steps tick coloring)
  successGreenAll: {
    50: '#74B65F',
    100: '#74B65F',
    200: '#74B65F',
    300: '#74B65F',
    400: '#74B65F',
    500: '#74B65F',
    600: '#74B65F',
    700: '#74B65F',
    800: '#74B65F',
    900: '#74B65F',
  },
};

const styles = {
  fonts: {
    abcWhyteInktrap: 'ABC Whyte Inktrap',
    abcWhyte: 'ABC Whyte Book',
  },
  fontWeights: {
    book: 350,
  },
  colors,
  textStyles: {
    body: {
      fontFamily: 'ABC Whyte Inktrap',
      fontSize: '16px',
      lineHeight: '135%',
      letterSpacing: '-0.04em',
      color: colors.richBlack,
    },
    bodyGrey: {
      fontFamily: 'ABC Whyte Inktrap',
      fontSize: '16px',
      lineHeight: '135%',
      letterSpacing: '-0.04em',
      color: colors.grey2,
    },
    bodyGrey2: {
      fontFamily: 'ABC Whyte Book',
      fontSize: '16px',
      lineHeight: '135%',
      letterSpacing: '-0.04em',
      color: colors.grey2,
    },
    button: {
      fontFamily: 'ABC Whyte Book',
      fontSize: '16px',
      lineHeight: '135%',
      color: 'white',
    },
    buttonLight: {
      fontFamily: 'ABC Whyte Book',
      fontSize: '16px',
      lineHeight: '135%',
      color: 'black',
    },
    errorMessage: {
      fontFamily: 'ABC Whyte Book',
      fontSize: '16px',
      lineHeight: '135%',
      letterSpacing: '-0.04em',
      color: colors.errorRed,
    },
    h1: {
      fontFamily: 'Ortica',
      fontSize: '50px',
      lineHeight: '105%',
      letterSpacing: '-0.04em',
      color: 'black',
    },
    h2: {
      fontFamily: 'ABC Whyte Inktrap',
      fontSize: '32px',
      lineHeight: '90%',
      letterSpacing: '-0.04em',
      color: 'black',
    },
    h3: {
      fontFamily: 'ABC Whyte Inktrap',
      fontSize: '24px',
      lineHeight: '90%',
      letterSpacing: '-0.04em',
      color: colors.richBlack,
    },
    h4: {
      fontFamily: 'ABC Whyte Inktrap',
      fontSize: '20px',
      lineHeight: '90%',
      letterSpacing: '-0.04em',
      color: colors.richBlack,
    },
    small: {
      fontFamily: 'ABC Whyte Book',
      fontSize: '12px',
      lineHeight: '135%',
      letterSpacing: '-0.04em',
      color: colors.grey1,
    },
    small2: {
      fontFamily: 'ABC Whyte Inktrap',
      fontSize: '12px',
      lineHeight: '135%',
      letterSpacing: '-0.04em',
      color: colors.grey1,
    },
    footer: {
      fontFamily: 'ABC Whyte Book',
      fontSize: '14px',
      lineHeight: '135%',
      letterSpacing: '-0.04em',
      color: colors.grey1,
    },
  },
  form: {
    button: {
      backgroundColor: colors.grey1,
    },
    buttonLight: {
      backgroundColor: colors.grey100,
    },
    label: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    input: {
      fontFamily: 'ABC Whyte Book',
      fontSize: '14px',
      lineHeight: '135%',
      letterSpacing: '-0.04em',
      padding: '10px',
      color: colors.grey1,
      border: '1px solid',
      borderColor: colors.grey5,
    },
    addressInput: {
      minWidth: '22em',
      textAlign: 'right',
      fontFamily: 'ABC Whyte Book',
      fontSize: '14px',
      lineHeight: '135%',
      letterSpacing: '-0.04em',
      color: colors.grey1,
    },
  },
};

export default styles;
